import {JSX} from "react";

type Props = {}
function ErrorPage(props: Props): JSX.Element {
    return(<div>Error Page</div>)
}
export {ErrorPage};
